import React from 'react';
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import useStyles from "./styles"
import Post from "./post/post";

const Posts = ({ setCurrentId }) =>
{

  const posts = useSelector((state) => state.posts);
  const classes = useStyles();

  /**
   * If no posts display loading
   * If posts loop through each and create an individual post element
   */

  return (
    !posts.length ? <div><p>Loading...</p></div> : (
      <div>
        {posts.map((post) =>
        (
          <Post key={post._id} post={post} setCurrentId={setCurrentId}></Post>
        ))}
      </div>
    )
  );
}

export default Posts;